import { call, put, takeLatest } from "redux-saga/effects";
import { callAPI, handleError, handleSuccess } from "../api/api";
import axios from "axios";
import { setLoaderAction, setNotificationAction } from "../reducers/mmymSlice";
import { addSaleAction, deleteSaleAction, getAllSaleAction, setAddSaleResponse, setAllSaleAction, updateSaleAction } from "../reducers/saleSlice";


/**
 * This function for call the user profile
 *
 * @param {*} payload
 */

function* getAllSaleSaga(): any {
  yield put(setLoaderAction(true));
  try {
    const res = yield call<any>(callAPI, {}, "get", `client/settings/sales`);
    if (res?.data) {
      yield put(setAllSaleAction(res?.data));
    }
  } catch (error) {
    console.log("Catch Error-", error);
  }
  yield put(setLoaderAction(false));
}

function* addSaleSaga(payload: any[]): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const apiResponse = yield call<any>(
      callAPI,
      payload,
      "post",
      "client/settings/sales"
    );
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setAddSaleResponse(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setAddSaleResponse(false));
  }
  yield put(setLoaderAction(false));
}

function* updateSaleSaga(payload: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const {id} = payload?.payload;
    const apiResponse = yield call<any>(
      callAPI,
      payload,
      "post",
      `client/settings/sales/${id}`
    );
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setAddSaleResponse(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setAddSaleResponse(false));
  }
  yield put(setLoaderAction(false));
}

function* deleteSaleSaga(payload: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const apiResponse = yield call<any>(
      callAPI,
      {},
      "delete",
      `client/settings/sales/${payload?.payload?.id}`
    );
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setAddSaleResponse(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setAddSaleResponse(false));
  }
  yield put(setLoaderAction(false));
}

export function* watchSale() {
  yield takeLatest<any>(getAllSaleAction, getAllSaleSaga);
  yield takeLatest<any>(addSaleAction, addSaleSaga);
  yield takeLatest<any>(updateSaleAction,updateSaleSaga);
  yield takeLatest<any>(deleteSaleAction,deleteSaleSaga);
}
